module.exports = __webpack_public_path__ + "static/media/belcolor__2.b6ce81cd.jpg";